<ng-container class="add-config-modal-container">
  <div class="configuration-treated-container">
    <app-configuration-created-info *ngIf="configurationName" [configurationName]="configurationName"> </app-configuration-created-info>
  </div>
  <div *ngIf="!isLoaded; else inputs" class="loader-wrapper">
    <app-loader></app-loader>
  </div>

  <ng-template #inputs>
    <ng-container *ngFor="let field of modalConfigFields, index as i">
      <app-text-input
        (emitValue)="getValue($event)"
        *ngIf="inputTypes[field.type ?? ''] === 'text-input'"
        [configurationData]="configurationData"
        [fieldInfo]="field"
        [showAutofocus]="i === 0"
        [submitted]="submitted"
        [validators]="['required']">
      </app-text-input>
      <app-select-input
        (emitValue)="getValue($event)"
        *ngIf="inputTypes[field.type ?? ''] === 'select-input'"
        [configurationData]="configurationData"
        [fieldInfo]="field"
        [submitted]="submitted">
      </app-select-input>
      <ng-container *ngIf="!field.values?.length && field.type === 'domain'">
        <app-primary-button [icon]="'plus'" [iconSize]="12" [buttonText]="'add_direct_link'" [background]="'orange'" (emitAction)="handleAddDirectlinkModal()">
        </app-primary-button>
      </ng-container>
      <app-checkbox-input
        (emitValue)="getValue($event)"
        *ngIf="inputTypes[field.type ?? ''] === 'checkbox-input'"
        [configurationData]="configurationData"
        [fieldInfo]="field"
        [submitted]="submitted">
      </app-checkbox-input>
      <app-radio-input
        (emitValue)="getValue($event)"
        *ngIf="inputTypes[field.type ?? ''] === 'radio-input'"
        [configurationData]="configurationData"
        [fieldInfo]="field"
        [submitted]="submitted">
      </app-radio-input>
      <app-textarea-input
        (emitValue)="getValue($event)"
        *ngIf="inputTypes[field.type ?? ''] === 'textarea-input'"
        [configurationData]="configurationData"
        [fieldInfo]="field"
        [placeholder]="'add_name_and_description'"
        [submitted]="submitted">
      </app-textarea-input>
      <app-img-input (emitValue)="getValue($event)" *ngIf="inputTypes[field.type ?? ''] === 'img-input'" [fieldInfo]="field" [submitted]="submitted">
      </app-img-input>
      <!--      <div *ngIf="field.type === 'domain'" class="information-link">-->
      <!--        <a href="#" target="_blank">{{ 'view_translations.how_choose_tracking_domain' | translate }}</a>-->
      <!--      </div>-->
      <div *ngIf="field.type === 'domain'" class="information-custom-domain">
        <p>{{ 'need_your_domain' | t }}</p>
        <p>{{ 'need_your_domain_description' | t }}</p>
      </div>
    </ng-container>
  </ng-template>

  <ng-container *ngIf="(isSuccessfullySubmitted || configurationData) && landingOptions.length > 0">
    <app-input-select
      [label]="'choosing_landing_creation' | t"
      [options]="landingOptions"
      [required]="false"
      [submitted]="submitted"
      [multiple]="false"
      [large]="true"
      [search]="false"
      (emitChange)="getLanding($event)">
    </app-input-select>
  </ng-container>

  <div *ngIf="isSuccessfullySubmitted || configurationData" class="additional-link-paramters-container">
    <app-additional-link-parameters (emitSubs)="getSubs($event)"></app-additional-link-parameters>
  </div>

  <div *ngIf="isSuccessfullySubmitted || configurationData" class="generated-url-container">
    <app-generated-url [generatedURL]="generatedURL"></app-generated-url>
  </div>
  <div *ngIf="( showEditButton && configurationData ) || !configurationData" class="btn-container">
    <app-primary-button
      (emitAction)="performAction()"
      [background]="'orange'"
      [buttonText]="isSuccessfullySubmitted ? 'back_to_configuration_list' : (configurationData ? 'edit_configuration_modal' : 'add_configuration_button_label')"
      [iconSize]="12"
      [icon]="isSuccessfullySubmitted || configurationData ? '' : 'plus'">
    </app-primary-button>
  </div>
</ng-container>
